import '../../styles/auth.css';
import { forgotPassword } from '../../auth';
import { bootShell, showError, showSuccess, clearMessages, describeError } from './_shell';

bootShell();

const form = document.getElementById('forgot-form') as HTMLFormElement;
const emailInput = document.getElementById('email') as HTMLInputElement;
const submitBtn = document.getElementById('submit-btn') as HTMLButtonElement;

form.addEventListener('submit', async (ev) => {
  ev.preventDefault();
  clearMessages();

  const email = emailInput.value.trim();
  if (!email) {
    showError('Enter your email.');
    return;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    showError('That email does not look right.');
    return;
  }

  submitBtn.disabled = true;
  try {
    await forgotPassword(email);
  } catch (err: any) {
    // Even on a real network error we still show the generic "if exists"
    // message — except for 5xx, where surfacing the failure helps the user
    // know to retry.
    if (err?.status >= 500) {
      showError(describeError(err, 'Could not send the reset email.'));
      submitBtn.disabled = false;
      return;
    }
  }
  // Always show the same message regardless of whether the email exists —
  // this is the standard "no enumeration" pattern.
  showSuccess('If that email is registered, a reset link is on its way. Check your inbox (and spam).');
  emailInput.value = '';
  submitBtn.disabled = false;
});
